<template>
  <role-form
    :role="role"
    :title="$t('label.editRole')"
    :validations="validations"
    @submit="onSubmit"
  />
</template>

<script>
import RoleForm from './Form'

export default {
  name: 'EditRole',
  metaInfo () {
    return {
      title: this.$t('string.editNewRole'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    RoleForm
  },
  data () {
    return {
      role: undefined,
      validations: null
    }
  },
  methods: {
    onSubmit (role) {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/role/edit', {
        name: role.name,
        guard_name: 'web',
        permissions: role.permissions.map(permission => (
          {
            id: permission.id,
            name: permission.name
          }
        )),
        display_name_en: role.display_name_en,
        display_name_km: role.display_name_km,
        id: this.$route.params.id
      }).then(() => {
        this.$swal(this.$t('label.swal.success'), this.$t('label.roleUpdated'), 'success')
          .then(() => {
            this.$router.back()
          })
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        }
        this.onResponseError(error)
      })
    },
    getRole (id) {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/role/get-role', {
        id: id
      }).then((response) => {
        this.role = response.data.data
      }).catch(error => {
        this.onResponseError(error)
      })
    }
  },
  mounted () {
    this.getRole(this.$route.params.id)
  }
}
</script>

<style scoped>

</style>
